const React = require('react');

const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');

const MessageAOPO = require('../../../../components/MessageAOPO');
const Page = require('../../../../components/Page');
const ButtonBackURLs = require('../../../../components/ButtonBackURLs');
const stepActionCreators = require('../../../../spa/actions/step');
const Navbar = require('@cow/core-components/components/NavbarV2');
const Optimus = require('../../../../containers/Optimus');
const CardListLoggedSection = require('../components/CardListLoggedSection');
const PaidWithCashSection = require('../components/PaidWithCashSection');
const PaymentOptionPropTypes = require('../templatePropTypes');
const { useNavbar } = require('../../../../hooks/useNavbar');

const { Title } = require('@andes/typography');
const { CoachMarks } = require('@andes/coach-marks');
const translate = require('../../../../translation');
const Footer = require('@cow/core-components/components/Footer');
const PaymentSummary = require('@cow/core-components/components/PaymentSummary');
const Brand = require('@cow/core-components/components/Brand');
const GenericModal = require('@cow/core-components/components/GenericModal');
const {
  handleSummaryItemProps,
  PAYMENT_SUMMARY_ALIGNMENT,
} = require('../../../../utils/summary');
const { THEME } = require('../../../../../constants/commons');
const {
  COMMONS: {
    CHECKOUT_TYPE: { MODAL },
    DEVICE_TYPE: { MOBILE },
    ENVIROMENT,
    CHECKOUT_CASE: { SUBSCRIPTION },
  },
  SELECTORS
} = require('../../../../../constants');
const { MESSAGE_LOCATIONS } = require('../constants/constant');
const classNames = require('classnames');

const PaymentOptionsDesktopLogged = (props) => {
  const [showDiscountModal, setShowDiscountModal] = React.useState(false);
  const translations = translate(props.i18n);
  const { showNavbar } = useNavbar(props.flow, !props.userLogged, props.configs?.isWebview);
  const notNavbar = !showNavbar ? SELECTORS.NOT_NAVBAR : SELECTORS.LOGGED;
  const tooltipContainer = React.createRef();

  const { summary, summaryFromComponents } = props.frontendData;

  const aboveMessage = props.frontendData.regulations?.find(regulation => regulation?.value?.location === MESSAGE_LOCATIONS.above);
  const belowMessage = props.frontendData.regulations?.find(regulation => regulation?.value?.location === MESSAGE_LOCATIONS.below);

  return (
    <Page
      title={props.frontendData.pageTitle}
      currentStep={props.currentStep}
      urls={props.urls}
      trackingPath={props.trackingPath}
      analytics={props.analytics}
      deviceType={props.deviceType}
    >
      <CoachMarks
        run={props.frontendData.showCoachMark}
        disableScrolling
        steps={props.frontendData.stepsCoachMark}
        locale={{
          back: translations.TO_GO_BACK,
          last: translations.I_UNDERSTAND,
          next: translations.CONTINUE,
        }}
        onChange={props.frontendData.onChangeCoachMark}
      />

      {showNavbar && <Navbar {...props.frontendData.navbar} />}

      <section className={`payment-option-desktop-screen payment-option-desktop-screen${notNavbar}`}>
        <div className="payment-option-desktop-screen__content">
          <Title component="h1" size="s" className="payment-option-desktop-screen__content-title">
            {props.frontendData.pageTitle}
          </Title>

          {aboveMessage &&
            <MessageAOPO
              title={aboveMessage.value.title}
              message={aboveMessage.value.text}
              closable={aboveMessage.value.closable}
              location={aboveMessage.value.location}
              color={aboveMessage.value.message_type}
            />
          }

          <div
            className={classNames('payment-option-desktop-screen__content-card-list', {
              [SELECTORS.REBRANDING]: props.configs?.rebrandingMP,
            })}
          >
            {!props.frontendData.showPayWithCashScreen && (
              <CardListLoggedSection
                i18n={props.i18n}
                hasCombination={props.frontendData.combination}
                paymentByAccountMoney={props.frontendData.paymentByAccountMoney}
                rows={props.frontendData.rows}
                moreThanTwoCards={props.frontendData.moreThanTwoCards}
                creditsAndOpenFinance={props.frontendData.creditsAndOpenFinance}
                otherPaymentMethods={props.frontendData.otherPaymentMethods}
                goToScreen={props.frontendData.goToScreen}
                goToCombinationScreen={props.frontendData.goToCombinationScreen}
                deviceType={props.deviceType}
                showPayWithCashSection={props.frontendData.showPayWithCash}
                isTheOptionToPayWithCash={props.frontendData.isTheOptionToPayWithCash}
                siteId={props.siteId}
              />
            )}

            {props.frontendData.showPayWithCashScreen && (
              <PaidWithCashSection
                {...props.frontendData.payWithCash[props.frontendData.showPayWithCashScreen]}
                onClickMethod={props.frontendData.goToStorePage}
                onNavigationBack={props.frontendData.hidePayWithCash}
              />
            )}

            {belowMessage &&
              <MessageAOPO
                title={belowMessage.value.title}
                message={belowMessage.value.text}
                location={belowMessage.value.location}
                closable={belowMessage.value.closable}
                color={belowMessage.value.message_type}
              />
            }

            {props.frontendData.backButton?.url && props.frontendData.backButton?.title && (
              <ButtonBackURLs label={props.frontendData.backButton?.title} url={props.frontendData.backButton?.url} />
            )}
          </div>
        </div>

        {summary ? (
          <section className="layout__col-sidebar">
            {props.frontendData.brand && (
              <Brand image={props.frontendData.brand.avatar} name={props.frontendData.brand.name} />
            )}

            <PaymentSummary
              theme={THEME.DARK}
              showSubmitButton={false}
              title={summary?.title}
              items={(summary?.items ?? [])
                .map((item) =>
                  handleSummaryItemProps({
                    item,
                    summary,
                    showTaxes: props.frontendData.showTaxes,
                    translations,
                    tooltipContainer,
                    setShowDiscountModal,
                    deviceType: props.deviceType,
                    iconAlignment: PAYMENT_SUMMARY_ALIGNMENT.LEFT,
                    isSubscription: props.frontendData.transaction_type === SUBSCRIPTION,
                  }),
                )
                .filter((item) => item)}

              total={summary?.total && {
                name: summary?.total?.name,
                nameWeight: 'regular',
                price: summary?.total?.price.text_value,
                priceWeight: 'regular',
                priceCents: summary?.total?.price.cents,
                priceSize: 16,
                textSize: 'm',
              }}
            />
          </section>
        ) : (
          <Optimus
            components={summaryFromComponents}
            history={props.history}
            siteId={props.siteId}
            urls={props.urls}
            publicKey={props.publicKey}
            deviceType={props.deviceType}
            captcha={props.captcha}
            hiddenComponents={props.hidden_components}
          />
        )}

        {props.frontendData.discount?.is_applicable && (
          <GenericModal
            className="discount-modal"
            title={translations.GENERAL_CONDITIONS}
            content={<>{props.frontendData.discount?.detail}</>}
            isOpen={showDiscountModal}
            deviceType={props.deviceType}
            onClose={() => setShowDiscountModal(false)}
            onOpen={() => setShowDiscountModal(true)}
          />
        )}

        { // INFO: The Footer component escapes when it is MODAL because, in modal, the footer is incorporated into the content section.
          props.checkoutType !== MODAL &&
          !props.frontendData.showPayWithCashScreen &&
          <section className="layout__col-footer">
            <Footer
              requiredMessage={props.frontendData.footer.requiredMessage}
              requiredScreenReaderMessage={props.frontendData.footer.requiredScreenReaderMessage}
              deviceType={props.deviceType}
            />
          </section>
        }
      </section>

    </Page>
  );
};

PaymentOptionsDesktopLogged.propTypes = PaymentOptionPropTypes;

/* istanbul ignore next: cant test it with tests */
const mapStateToProps = (state) => ({
  flow: state.page.flow,
});

/* istanbul ignore next: cant test it with tests */
const mapDispatchToProps = (dispatch) => ({
  stepActions: bindActionCreators(stepActionCreators, dispatch),
});

if (process.env.NODE_ENV === ENVIROMENT.TEST) {
  module.exports = PaymentOptionsDesktopLogged;
} else {
  /* istanbul ignore next: cant test it with tests */
  module.exports = connect(mapStateToProps, mapDispatchToProps)(PaymentOptionsDesktopLogged);
}
